<template>
  <div class="container">
    <div class="wrapper">
      <div class="dialog">
        <div class="title">{{ title }}</div>
        <div class="priceinput">
          <div class="pricevalue">
            <GimoCoinSymbol></GimoCoinSymbol>
            <span class="inputvalue" :class="firstClick && 'firstInput'">{{ $utils.numberFormat(inputValue * 1000) }}</span>
          </div>
          <ion-button fill="outline" expand="block" color="tertiary" @click="inputClick(0)">
            <ion-icon slot="icon-only" :icon="backspaceOutline"></ion-icon>
          </ion-button>
          <ion-button fill="outline" expand="block" size="small" color="tertiary" @click="inputClick(10)">10 K</ion-button>
          <ion-button fill="outline" expand="block" size="small" color="tertiary" @click="inputClick(20)">20 K</ion-button>
          <ion-button fill="outline" expand="block" size="small" color="tertiary" @click="inputClick(50)">50 K</ion-button>
          <ion-button fill="outline" expand="block" size="small" color="tertiary" @click="inputClick(100)">100 K</ion-button>
          <ion-button fill="outline" expand="block" size="small" color="tertiary" @click="inputClick(200)">200 K</ion-button>
          <ion-button fill="outline" expand="block" size="small" color="tertiary" @click="inputClick(500)">500 K</ion-button>
        </div>
        <div class="buttons">
          <ion-button fill="outline" expand="block" color="medium" @click="cancel()">Hủy chọn</ion-button>
          <ion-button fill="solid" expand="block" @click="updateValue">Xác nhận</ion-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .container {
    height: 100%;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    .wrapper {
      margin: 0;
      padding: 0;
      display: flex;
      justify-content: center;
      .dialog {
        width: 100%;
        margin: 0;
        padding: 0;
        background-color: #fff;
        .title {
          background-color: #ccc;
          color: #333;
          text-align: center;
          padding: 1vh;
        }
        .priceinput {
          display: grid;
          grid-template-columns: auto auto auto auto auto auto;
          .pricevalue {
            grid-column: 1 / span 5;
            border: 1px solid #5260ff;
            margin: 4px;
            border-radius: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1vw 2vw;
            GimoCoinSymbol {
              margin: 0 1vw;
            }
            .inputvalue {
              margin: 0 1vw;
              display: block;
              text-align: right;
              font-size: 1.3em;
              &.firstInput {
                color: #fff;
                background-color: #5260ff;
              }
            }
          }
        }
        .buttons {
          display: flex;
          flex-direction: row;
          ion-button {
            flex: 1;
          }
        }
      }
    }
  }
</style>

<script>
  import {
    IonButton,
    IonIcon,
    // IonRippleEffect,
    modalController,
    toastController,
  } from '@ionic/vue';
  import {
    closeCircle,
    checkmarkCircle,
    ellipseOutline,
    backspaceOutline
  } from 'ionicons/icons'
  import { defineComponent } from 'vue';
  import { clone } from 'lodash';
  import GimoCoinSymbol from './GimoCoinSymbol.vue';

  export default defineComponent({
    name: 'PriceInputModal',
    components: {
      // IonRippleEffect,
      IonIcon,
      IonButton,
      GimoCoinSymbol,
    },
    props: {
      title: String,
      options: Object,
      value: [Number, String],
      rtl: Boolean,
      iconSize: String,
      max: Number,
      min: Number,
      errorMaxMsg: String,
      errorMinMsg: String,
    },
    data() {
      return {
        firstClick: false,
        inputValue: 10
      }
    },
    mounted() {
      this.inputValue = parseInt(clone(this.value));
    },
    methods: {
      cancel() {
        modalController.dismiss({
          cancel: true
        });
      },
      async updateValue() {
        if (this.inputValue < this.min) {
          const toast = await toastController
            .create({
              message: this.errorMinMsg+' '+ this.$utils.numberFormat(this.min*1000) +' G',
              position: 'middle',
              duration: 1500,
              color: 'danger',
              buttons: [
                {
                  side: 'end',
                  icon: 'close',
                  role: 'cancel',
                  handler: () => {
                    console.log('Cancel clicked');
                  }
                }
              ]
            });
            return toast.present();
        }
        modalController.dismiss({
          cancel: false,
          value: this.inputValue
        });
      },
      inputClick(val) {
        if (val == 0) {
          this.firstClick = true;
          this.inputValue = 0;
          return;
        }
        if (this.inputValue + val > this.max) {
          this.inputValue = this.max;
          this.openToastOptions();
        } else {
          this.inputValue += val;
        }
        if (this.firstClick) {
          this.firstClick = false;
          return;
        }
      },
      async openToastOptions() {
        const toast = await toastController
          .create({
            message: this.errorMaxMsg+' '+ this.$utils.numberFormat(this.max*1000) +' G',
            position: 'middle',
            duration: 1500,
            color: 'danger',
            buttons: [
              {
                side: 'end',
                icon: 'close',
                role: 'cancel',
                handler: () => {
                  console.log('Cancel clicked');
                }
              }
            ]
          })
        return toast.present();
      },
    },
    setup() {
      return {
        closeCircle,
        checkmarkCircle,
        ellipseOutline,
        backspaceOutline,
      }
    }
  })
</script>
